var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useModal } from "../Shared/components/Modal";
import { Checkout } from "./Checkout";
import { CheckoutText } from "./Checkout-types";
import { CheckoutContext } from "./CheckoutContext";
import { CheckoutSkeleton } from "./CheckoutSkeleton";
import { NavigationWarningModal } from "./NavigationWarningModal";
import { GiftCardCheckout } from "./GiftCardCheckout/GiftCardCheckout";
import { showOverlappingOrderWarning } from "./OverlappingOrderWarning/OverlappingOrderWarning-utils";
import { useCheckout } from "./useCheckout";
import { useCompanyConfigQuery } from "../SWR/Company/useCompanyConfigQuery";
export const CheckoutShell = () => {
    var _a, _b;
    const navigate = useNavigate();
    const { orderInfo } = useContext(CheckoutContext);
    const location = useLocation();
    const orderFlowState = (_a = location.state) === null || _a === void 0 ? void 0 : _a.orderFlowState;
    const giftCardState = (_b = location.state) === null || _b === void 0 ? void 0 : _b.giftCardState;
    const _c = useCheckout(), { loading: checkoutInfoLoading, validEmail, emailErrorText, paymentSectionText, paymentSectionTitle, overlappingStatus, isNavigationWarningOpen, handleStayOnPage, handleLeavePage } = _c, rest = __rest(_c, ["loading", "validEmail", "emailErrorText", "paymentSectionText", "paymentSectionTitle", "overlappingStatus", "isNavigationWarningOpen", "handleStayOnPage", "handleLeavePage"]);
    const { showModal, closeModal } = useModal();
    const showSkeleton = checkoutInfoLoading || (!giftCardState && orderInfo === undefined);
    const { tokenMap } = useCompanyConfigQuery();
    useEffect(() => {
        if (overlappingStatus) {
            showOverlappingOrderWarning(overlappingStatus, navigate, showModal, closeModal, orderFlowState === null || orderFlowState === void 0 ? void 0 : orderFlowState.sku, tokenMap);
        }
    }, [overlappingStatus]);
    if (!validEmail && !showSkeleton) {
        return (_jsxs(_Fragment, { children: [_jsx(Typography, { children: emailErrorText }), _jsx(Button, Object.assign({ size: "medium", color: "primary", variant: "contained", onClick: () => navigate(`/Account/Orders`, { replace: true }) }, { children: CheckoutText.GO_TO_ACCOUNT }))] }));
    }
    if (showSkeleton) {
        return _jsx(CheckoutSkeleton, {});
    }
    return (_jsxs(_Fragment, { children: [giftCardState ? (_jsx(GiftCardCheckout, { checkoutInfoLoading: checkoutInfoLoading, paymentSectionText: paymentSectionText, paymentSectionTitle: paymentSectionTitle })) : (_jsx(Checkout, Object.assign({}, rest, { checkoutInfoLoading: checkoutInfoLoading }))), _jsx(NavigationWarningModal, { isOpen: isNavigationWarningOpen, onStay: handleStayOnPage, onLeave: handleLeavePage })] }));
};
